import { render, staticRenderFns } from "./UcSuggestProductOption.yaml?vue&type=template&id=8665e202&component"
import script from "./UcSuggestProductOption.yaml?vue&type=script&lang=ts&component"
export * from "./UcSuggestProductOption.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports